(function ($, Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.krTab = {
    runZoom: function () {
      var modalMapImage = $('.kr-partner-map__modal-container img');
      if (modalMapImage) {
        modalMapImage.elevateZoom({
          cursor: 'crosshair'
        });
      }
    },

    attach: function (context, settings) {
      $(once('tab-functions', '.component-kr-tab', context)).each(function () {
        var mapModal = $('.kr-partner-map__modal');
        var mapModalContainer = $('.kr-partner-map__modal .kr-partner-map__modal-container');
        var mapModalTrigger = $(this).find('.kr-partner-map__modal-link button');
        var mapModalClose = $('.kr-partner-map__close');
        var pid = $(mapModalTrigger).data('pid');

        function getMapImage() {
          $.get('/kidreviewed/map-modal/' + pid, function (data) {
            $(mapModalContainer).append(data);
            $('.kr-partner-map__modal-loader').css('display', 'none');
            Drupal.blazy.init.revalidate();
            if (window.innerWidth >= 788) {
              Drupal.behaviors.krTab.runZoom();
            }
            $('.kr-partner-map__close').css('display', 'block');
          });
        }

        function loadModal() {
          $(mapModal).css('display', 'flex');
          getMapImage();
        }

        $(mapModalTrigger).on('click touchstart', function () {
          $('.kr-partner-map__modal-loader').css('display', 'block');
          loadModal();
        });

        $(mapModalClose).on('click touchstart', function () {
          $('.zoomContainer').hide();
          $(mapModal).css('display', 'none');
          $('.kr-partner-map__close').css('display', 'none');
          $('.kr-partner-map__modal > .kr-partner-map__modal-container > img').remove();
        });
      });
    }
  };

  Drupal.behaviors.changeKrTabSpacing = {
    attach: function (context, settings) {
      $(once('change-spacing', '.component-kr-tab', context)).each(function () {
        if ($('.kr-partner-map__map-image-container').length) {
          $('.kr-laugh-tracker-title-suffix').css('margin-bottom', '0');
        }
      });
    }
  };

})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
